import React from "react";
import { Box, Button, TextareaAutosize, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function InlineEmbed({
  setOpenInlineEmbed,
  formName,
  setInlineEmbedColors,
  inlineEmbedColors,
  getCodeContent,
  handleSaveChanges,
}: any) {
  const handleDropdownClick = () => {
    document.getElementById("colorPickerInput")?.click();
  };
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div
          style={{
            color: "#667085",
            fontSize: "13px",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
          }}
        >
          <KeyboardBackspaceIcon onClick={() => setOpenInlineEmbed(false)} />
        </div>
        <CloseIcon
          onClick={() => setOpenInlineEmbed(false)}
          style={{ cursor: "pointer", color: "#667085" }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        <Typography
          sx={{ color: "#142C44", fontSize: "18px", fontWeight: "600" }}
        >
          Inline Embed
        </Typography>
        <Typography
          sx={{ color: "#667085", fontSize: "13px", fontWeight: "500" }}
        >
          {formName}
        </Typography>
      </Box>
      <div
        style={{
          marginTop: "20px",
        }}
      >
        <div
          style={{
            color: "#323B4B",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          Webform Settings
        </div>
        <div style={{ color: "#667085", fontSize: "14px", fontWeight: "400" }}>
          Customize the look of the Webform to be displayed on your site.
        </div>
      </div>
      <div
        style={{ display: "flex", flexDirection: "column", marginTop: "20px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              color: "#667085",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            Background Color
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D6D6D6",
            }}
          >
            <input
              type="color"
              id="bgColorPickerInput"
              name="colorPicker"
              style={{
                border: "none",
                outline: "none",
              }}
              value={inlineEmbedColors?.bgColor}
              onChange={(event: any) => {
                setInlineEmbedColors({
                  ...inlineEmbedColors,
                  bgColor: event?.target.value,
                });
              }}
            />
            <label
              htmlFor="bgColorPickerInput"
              style={{ cursor: "pointer", color: "#BDBFC3", marginTop: "5px" }}
              onClick={handleDropdownClick}
            >
              <ArrowDropDownIcon />
            </label>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              color: "#667085",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            Text Color
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D6D6D6",
            }}
          >
            <input
              type="color"
              id="textColorPickerInput"
              name="colorPicker"
              value={inlineEmbedColors?.textColor}
              onChange={(event: any) => {
                setInlineEmbedColors({
                  ...inlineEmbedColors,
                  textColor: event?.target.value,
                });
              }}
              style={{
                border: "none",
                outline: "none",
              }}
            />
            <label
              htmlFor="textColorPickerInput"
              style={{ cursor: "pointer", color: "#BDBFC3", marginTop: "5px" }}
              onClick={handleDropdownClick}
            >
              <ArrowDropDownIcon />
            </label>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              color: "#667085",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            Button Background Color
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D6D6D6",
            }}
          >
            <input
              type="color"
              id="buttonBgColorPickerInput"
              name="colorPicker"
              style={{
                border: "none",
                outline: "none",
              }}
              value={inlineEmbedColors?.buttonBgColor}
              onChange={(event: any) => {
                setInlineEmbedColors({
                  ...inlineEmbedColors,
                  buttonBgColor: event?.target.value,
                });
              }}
            />
            <label
              htmlFor="buttonBgColorPickerInput"
              style={{ cursor: "pointer", color: "#BDBFC3", marginTop: "5px" }}
              onClick={handleDropdownClick}
            >
              <ArrowDropDownIcon />
            </label>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <div
            style={{
              color: "#667085",
              fontSize: "15px",
              fontWeight: "500",
            }}
          >
            Button Text Color
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #D6D6D6",
            }}
          >
            <input
              type="color"
              id="buttonTextColorPickerInput"
              name="colorPicker"
              style={{
                border: "none",
                outline: "none",
              }}
              value={inlineEmbedColors?.buttonTextColor}
              onChange={(event: any) => {
                setInlineEmbedColors({
                  ...inlineEmbedColors,
                  buttonTextColor: event?.target.value,
                });
              }}
            />
            <label
              htmlFor="buttonTextColorPickerInput"
              style={{ cursor: "pointer", color: "#BDBFC3", marginTop: "5px" }}
              onClick={handleDropdownClick}
            >
              <ArrowDropDownIcon />
            </label>
          </div>
        </div>
      </div>
      <Box
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "20px 0px",
        }}
      >
        <Button
          variant="contained"
          sx={{ textTransform: "capitalize" }}
          onClick={handleSaveChanges}
        >
          Save Changes
        </Button>
      </Box>
      <div
        style={{ display: "flex", flexDirection: "column", marginTop: "20px" }}
      >
        <div
          style={{
            color: "#323B4B",
            fontSize: "15px",
            fontWeight: "500",
          }}
        >
          Embed Code
        </div>
        <div
          style={{
            color: "#667085",
            fontSize: "14px",
            fontWeight: "500",
          }}
        >
          Place this code in your HTML where you want your Webform widget to
          appear.
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            overflow: "auto",
            backgroundColor: "#f5f5f5",
            borderRadius: "4px",
            padding: "10px",
            fontFamily: "monospace",
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
            margin: "10px 0",
            fontSize: "12px",
            height: "100px",
          }}
        >
          <pre>{getCodeContent()}</pre>
        </div>
      </div>
    </div>
  );
}

export default InlineEmbed;
